import { render } from "./DocCollectedCard.vue?vue&type=template&id=e8c25242"
import script from "./DocCollectedCard.vue?vue&type=script&lang=js"
export * from "./DocCollectedCard.vue?vue&type=script&lang=js"

import "./DocCollectedCard.vue?vue&type=style&index=0&id=e8c25242&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__